// Heritex industry suites — pre-bundled combinations of pillar products
// for a specific vertical. Each maps to an existing /products/<slug> detail
// page where applicable.

export const INDUSTRIES = [
  {
    slug: "healthcare",
    name: "Healthcare",
    brand: "TrataX One",
    icon: "HeartPulse",
    tagline: "Hospitals, clinics, labs — run on one calm OS.",
    image:
      "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?auto=format&fit=crop&w=1600&q=80",
    marketingSlug: "hospital-management",
    outcome: { value: "60%", label: "Less time per patient discharge" },
    pillars: [
      { slug: "sales", items: ["Patient CRM", "Appointment Booking"] },
      { slug: "operations", items: ["Doctor Scheduling", "Pharmacy Inventory", "Lab Workflow"] },
      { slug: "finance", items: ["Billing & Insurance", "TPA / Cashless"] },
      { slug: "customer-experience", items: ["Telemedicine", "Patient Portal"] },
      { slug: "ai", items: ["AI Receptionist Bot"] },
    ],
  },
  {
    slug: "faith",
    name: "Faith & Community",
    brand: "ChurchFlow",
    icon: "Church",
    tagline: "Churches, NGOs and faith-based communities.",
    image:
      "https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?auto=format&fit=crop&w=1600&q=80",
    marketingSlug: "church-management",
    outcome: { value: "3×", label: "Higher member engagement" },
    pillars: [
      { slug: "sales", items: ["Member CRM"] },
      { slug: "marketing", items: ["Bulk SMS / WhatsApp", "Email Updates"] },
      { slug: "finance", items: ["Online Giving & 80G"] },
      { slug: "operations", items: ["Service Planning", "Small Groups", "Events"] },
      { slug: "build", items: ["Branded Member App"] },
    ],
  },
  {
    slug: "education",
    name: "Education",
    brand: "School ERP",
    icon: "GraduationCap",
    tagline: "Pre-school to university — academic + admin in one.",
    image:
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80",
    marketingSlug: "school-erp",
    outcome: { value: "80%", label: "Manual paperwork eliminated" },
    pillars: [
      { slug: "sales", items: ["Admissions CRM"] },
      { slug: "operations", items: ["Attendance", "Timetable", "Exams"] },
      { slug: "finance", items: ["Fees & Late Fines", "GST Invoices"] },
      { slug: "customer-experience", items: ["Parent App", "Communication Hub"] },
      { slug: "build", items: ["Branded Parent / Student App"] },
    ],
  },
  {
    slug: "real-estate",
    name: "Real Estate",
    brand: "Heritex Estate",
    icon: "Home",
    tagline: "Builders, brokers, channel partners.",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1600&q=80",
    marketingSlug: "custom-crm",
    outcome: { value: "2×", label: "More site visits per lead" },
    pillars: [
      { slug: "sales", items: ["Lead → Site Visit Pipeline", "Broker Payouts"] },
      { slug: "marketing", items: ["Project Microsites", "WhatsApp Drip"] },
      { slug: "finance", items: ["Token & Booking Payments"] },
      { slug: "ai", items: ["Property Recommender Bot"] },
      { slug: "build", items: ["Listings Website + App"] },
    ],
  },
  {
    slug: "retail",
    name: "Retail & F&B",
    brand: "Heritex Retail",
    icon: "ShoppingBag",
    tagline: "Stores, brands, restaurants and cafés.",
    image:
      "https://images.unsplash.com/photo-1521335751473-9cef5d8a4296?auto=format&fit=crop&w=1600&q=80",
    marketingSlug: "e-commerce",
    outcome: { value: "2.4×", label: "Mobile conversion lift" },
    pillars: [
      { slug: "commerce", items: ["Storefront", "POS", "Restaurant Ordering"] },
      { slug: "marketing", items: ["WhatsApp Campaigns", "Loyalty"] },
      { slug: "customer-experience", items: ["Reviews & NPS"] },
      { slug: "operations", items: ["Inventory", "Multi-branch"] },
      { slug: "finance", items: ["Daily Reconciliation"] },
    ],
  },
  {
    slug: "hospitality",
    name: "Hospitality & Travel",
    brand: "Heritex Stays",
    icon: "BedDouble",
    tagline: "Hotels, resorts, villas, experience operators.",
    image:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1600&q=80",
    outcome: { value: "Direct", label: "Bookings, zero OTA cut" },
    pillars: [
      { slug: "commerce", items: ["Direct Bookings"] },
      { slug: "sales", items: ["Guest CRM", "Corporate Sales"] },
      { slug: "marketing", items: ["Pre-arrival Emails", "Reviews Loop"] },
      { slug: "operations", items: ["Front Desk", "Housekeeping"] },
      { slug: "ai", items: ["AI Concierge Bot"] },
    ],
  },
  {
    slug: "wellness",
    name: "Wellness & Fitness",
    brand: "Heritex Wellness",
    icon: "HeartPulse",
    tagline: "Gyms, studios, spas, coaches, clinics.",
    image:
      "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=1600&q=80",
    outcome: { value: "Members", label: "Retained 2× longer with apps" },
    pillars: [
      { slug: "commerce", items: ["Class & Session Booking", "Memberships"] },
      { slug: "sales", items: ["Member CRM"] },
      { slug: "marketing", items: ["Renewal Reminders", "Referral Loop"] },
      { slug: "customer-experience", items: ["Member App", "Progress Tracking"] },
    ],
  },
  {
    slug: "professional-services",
    name: "Professional Services",
    brand: "Heritex Pro",
    icon: "Briefcase",
    tagline: "Agencies, consultancies, law, accounting, coaching.",
    image:
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1600&q=80",
    outcome: { value: "100%", label: "Project margin visibility" },
    pillars: [
      { slug: "sales", items: ["Lead Pipeline", "Proposals"] },
      { slug: "operations", items: ["Project Management", "Time Tracking"] },
      { slug: "finance", items: ["Retainers", "Invoicing"] },
      { slug: "hr", items: ["Team & Utilisation"] },
    ],
  },
];

export const industryBySlug = Object.fromEntries(INDUSTRIES.map((i) => [i.slug, i]));
